export enum DefaultStatesEnum {
  Draft = 0,
  Open = 2,
  Revise = 100,
  Approved = 101,
  Rejected = 102,
  Global = 103,
  Closed = 104,
}

/** Workflow type names returned by grid search, independent of configured state names. */
export enum GridStateType {
  Start = 'Start',
  Open = 'Open',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Closed = 'Closed',
  Archived = 'Archived',
}
